// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/stockactivities";

export {
  baseRoute,
}
/* No side effect */
